<script>
    // imports
    import { onMount } from 'svelte';
	import { getPageData } from './api.js';
	import Content from './components/Content.svelte';
	import Header from './components/Header.svelte';
    import Tailwindcss from './Tailwindcss.svelte';
    import AOS from 'aos';

    // init vars
    let dataPromise = getPageData();

    onMount(() => {
        // Animation: https://github.com/michalsnik/aos
        AOS.init({
            duration: 1200,
            easing: 'ease-out-quad',
            offset: 100,
            //delay: 300,
            throttleDelay: 99,
            disable: 'phone',
            mirror: false
        });
    });
</script>

{#await dataPromise then entries}
    <div class="flex flex-col">
        <div class="fixed z-50 w-full">
            <Header pageTitle={entries.pageTitle} />
        </div>
        <div class="flex-1">
            <Content entries={entries.pageContent} />
        </div>
    </div>
{:catch error}
    {error}
{/await}